import { z } from 'zod';

export const ProtocolSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const ProtocolWithCoordinatesSchema = ProtocolSchema.extend({
  coordinateNames: z.array(z.string()),
});

export type Protocol = z.infer<typeof ProtocolSchema>;
export type ProtocolWithCoordinates = z.infer<typeof ProtocolWithCoordinatesSchema>;
